export default "__VITE_ASSET__BznUSNLQ__"